import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=e2c4fec6"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
import style0 from "./Terms.vue?vue&type=style&index=0&id=e2c4fec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports